import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { Pill } from '@els/els-react--pill';
import { Icon } from '@els/els-react--icon';
import FlyoutContent, { optionShape } from '../Shared/FlyoutContent';

function OperatorsDropdown({ options, selected, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    setIsOpen((_isOpen) => !_isOpen);
  };

  return (
    <Flyout
      flyout={<FlyoutContent options={options} onSaveChange={onChange} setIsOpen={setIsOpen} />}
      shouldCloseOnESC
      isControlled
      isOpen={isOpen}>
      <Pill className="c-els-pill--icon-right" onClick={toggleIsOpen} id="operatorPill">
        {selected.label}
        <Icon
          className="c-els-pill__icon"
          isDecorative
          id="operatorIcon"
          sprite={isOpen ? 'ChevronUp' : 'ChevronDown'}
          a11y={{
            name: 'Operator',
            description: 'click to select an operator',
          }}
          size="xs"
          textAlignment="sub"
        />
      </Pill>
    </Flyout>
  );
}

OperatorsDropdown.propTypes = {
  options: PropTypes.arrayOf(optionShape).isRequired,
  selected: optionShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OperatorsDropdown;
